'use client';

import { useEffect } from 'react';

import type { GTMVariablesLoaderClientProps } from './gtm-variables-loader.types';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function GTMVariablesLoaderClient({
  placement,
  productType,
  sessionId,
  source,
}: GTMVariablesLoaderClientProps) {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      { placement },
      { product_type: productType },
      { src: source },
      { session_id: sessionId },
      { event: 'context_loaded' },
    );
  }, [placement, productType, sessionId, source]);

  return null;
}
